import { styled } from '@mui/material';

export const StyledWrapper = styled('div')(({ theme }) => ({
  display        : 'flex',
  flexDirection  : 'column-reverse',
  justifyContent : 'space-between',
  alignItems     : 'center',
  gap            : '26px',
  padding        : '0 43px',
  '> button'     : {
    width : '100%',
  },
  [theme.breakpoints.up('sm')] : {
    flexDirection : 'row',
    '> button'    : {
      flex  : '1',
      width : 'auto',
    },
  },
}));
